<template>
  <div class="UserAccount">
    <header-component></header-component>
    <div class="g-bg-gray">
      <div class="container-fluid">
        <transition name="fade">
          <div class="alert alert-success center alert-fixed" v-if="isSuccess"><i class="fa fa-check"></i> Changes Successfully Saved!</div>
        </transition>
        <div v-if="isLoading || isLoadingEdit" class="row g-pt-100">
          <page-loader></page-loader>
        </div>
        <div class="container account_info g-pt-70 g-pb-100"  v-else>
          <br id="errorDiv">
          <div class="row" v-if="Account.accountType!=1">
            <div class="col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-sm-12 col-xs-12 account_header btn-group account_header btn-group">
                <span class="btn active g-bg-main  g-color-white" href="#">
                  <h4 @click.self="SwitchTab('account', $event)">Account &amp; Contact</h4>
                </span>
                <!-- btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-font-size-17 -->
                <span class="btn btn-outline-primary" href="#">
                  <h4 @click.self="SwitchTab('doctors', $event)">Eye Doctors</h4>
                </span>
            </div>
          </div>
          <div class="account_header" v-else>
            <p class="header_title">My Account</p>
          </div>

          <div class="row">
            <div class="col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-sm-12 col-xs-12">
              <!-- <div class="row">
                <div class="col-lg-12">
                </div>
              </div> -->
              <div class="row" v-show="pageShown == 'account'">
                <login-info @clicked="GetEditValues()" @selfReload="GetAccountValues()" @load="StartLoad()" @success="SuccessFade()" v-bind:AccountView="AccountView" :LoginFormInputs="LoginFormInputs" :LoginEdit="LoginEdit" :isFormLoading="isFormLoading"></login-info>
                <account-info @clicked="GetEditValues()" @selfReload="GetAccountValues()" @load="StartLoad()" @success="SuccessFade()" v-bind:AccountView="AccountView" :AccountEdit="AccountEdit" :FormInputs="FormInputs" :AccountValidationResult="AccountValidationResult" :BusinessTypeIndividual="BusinessTypeIndividual" :BusinessTypeBusiness="BusinessTypeBusiness" :BusinessTypeNonProfit="BusinessTypeNonProfit" :Suffix="Suffix" :RoleNonProfit="RoleNonProfit" :RoleBusiness="RoleBusiness" :State="State" :isFormLoading="isFormLoading"></account-info>
                <location-info @clicked="GetEditValues()" @selfReload=" GetAccountValues()" @load="StartLoad()" @success="SuccessFade()" v-bind:AccountView="AccountView" :AccountEdit="AccountEdit" :FormInputs="FormInputs" :State="State" :RoleNonProfit="RoleNonProfit" :RoleBusiness="RoleBusiness" :isFormLoading="isFormLoading"></location-info>
                <forecasting-info @clicked="GetEditValues()" @selfReload="GetAccountValues()" @load="StartLoad()" @success="SuccessFade()" v-bind:AccountView="AccountView" :AccountEdit="AccountEdit" :FormInputs="FormInputs" :isFormLoading="isFormLoading"></forecasting-info>
                <eye-doctor-info v-if="Account.accountType==1" @clicked="GetEditValues()" @selfReload="GetAccountValues()" @load="StartLoad()" @success="SuccessFade()" @refreshDoctorForm="RefreshAddDoctorForm()" v-bind:AccountView="AccountView" :AccountEdit="AccountEdit" :FormInputs="FormInputs" :Suffix="Suffix" :State="State" :CheckboxIndividual="CheckboxIndividual" :isFormLoading="isFormLoading" :AccountValidationResult="AccountValidationResult" :NewDoctor="NewDoctor"></eye-doctor-info>
                <association-info @clicked="GetEditValues()" @selfReload="GetAccountValues()" @load="StartLoad()" @success="SuccessFade()" v-bind:AccountView="AccountView" :AccountEdit="AccountEdit" :FormInputs="FormInputs" :AccountValidationResult="AccountValidationResult" :isFormLoading="isFormLoading" :CheckboxBusiness="CheckboxBusiness"></association-info>
                <communication-info @clicked="GetEditValues()" @selfReload="GetAccountValues()" @load="StartLoad()" @success="SuccessFade()" v-bind:AccountView="AccountView" :AccountEdit="AccountEdit" :FormInputs="FormInputs" :isFormLoading="isFormLoading"></communication-info>
              </div>
              <div class="row" v-show="pageShown == 'doctors'" v-if="Account.accountType!=1">
                <eye-doctor-info @clicked="GetEditValues()" @selfReload="GetAccountValues()" @load="StartLoad()" @success="SuccessFade()" @refreshDoctorForm="RefreshAddDoctorForm()" v-bind:AccountView="AccountView" :AccountEdit="AccountEdit" :FormInputs="FormInputs" :Suffix="Suffix" :State="State" :CheckboxIndividual="CheckboxIndividual" :isFormLoading="isFormLoading" :AccountValidationResult="AccountValidationResult" :NewDoctor="NewDoctor"></eye-doctor-info>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-component></footer-component>
  </div>
</template>
<style scoped>
  .btn {
    border-radius: 15px 15px 0 0;
  }

  @media only screen and (max-width: 600px) {
    .btn > h4 {
      font-size: 1.2rem;
    }
  }
</style>
<script>
import HeaderComponent from "@/components/shared/HeaderComponent";
import FooterComponent from "@/components/shared/FooterComponent";
import LoginInfo from "@/components/portal/userAccount/accountData/LoginInfo";
import AccountInfo from "@/components/portal/userAccount/accountData/AccountInfo";
import LocationInfo from "@/components/portal/userAccount/accountData/LocationInfo";
import EyeDoctorInfo from "@/components/portal/userAccount/accountData/EyeDoctorInfo";
import ForecastingInfo from "@/components/portal/userAccount/accountData/ForecastingInfo";
import LabInfo from "@/components/portal/userAccount/accountData/LabInfo";
import AssociationInfo from "@/components/portal/userAccount/accountData/AssociationInfo";
import CommunicationInfo from "@/components/portal/userAccount/accountData/CommunicationInfo";
import PageLoader from "@/components/shared/PageLoader";
export default {
  components: {
    HeaderComponent,
    FooterComponent,
    LoginInfo,
    AccountInfo,
    LocationInfo,
    EyeDoctorInfo,
    ForecastingInfo,
    LabInfo,
    AssociationInfo,
    CommunicationInfo,
    PageLoader
  },
  data() {
    return {
      pageShown: "account",
      isSwitchingTabs: false,
      isSuccess: false,
      labels: null,
      isLoading: true,
      isLoadingEdit:true,
      isFormLoading: false,
      FormInputs: null,
      LoginFormInputs: null,
      isSubmitFail: false,
      called: "",
      TermsEmail: {
        Subject: "Terms and Conditions",
        Name: "",
        Email: "",
        Message: ""
      },
      BusinessEmail: {
        Subject: "Business Associate Agreement",
        Name: "",
        Email: "",
        Message: ""
      },
      Account: {},
      AccountView: {},
      AccountEdit: {},
      NewDoctor: {
        useLicenseNumber:false,
        npiNumber:null,
        licenseNumber:null,
        state:null,
        firstName:null,
        lastName:null,
        suffix:null,
        emailAddress:null,
        yearsInPractice:null,
        organizations: {
          list: [],
          others: null
        },
        id: 0
      },
      AccountEnums: [
        "Suffix",
        "State",
        "BusinessTypeIndividual",
        "BusinessTypeBusiness",
        "BusinessTypeNonProfit",
        "RoleBusiness",
        "RoleNonProfit",
        "OrganizationIndividual",
        "OrganizationBusinessCFS"
      ],
      State: {},
      Suffix: {},
      BusinessTypeIndividual: {},
      BusinessTypeBusiness: {},
      BusinessTypeNonProfit: {},
      RoleBusiness: {},
      RoleNonProfit: {},
      CheckboxIndividual: {},
      CheckboxBusiness: {},
      AccountValidationResult: {},
      LoginEdit: {
        emailAddress: "",
        emailAddressConfirm: "",
        password: "",
        newPassword: "",
        newPasswordConfirm: ""
      }
    }
  },
  methods: {
    SwitchTab(tab, event){
      console.log(this.Account.accountType);
        if (this.pageShown == tab)
          return;

        var els = this.$el.querySelectorAll('.active');

        for (var e of els)
          e.className = "btn btn-outline-primary";

        // event.target.parentElement.className = "nav-link active g-color-white g-bg-main g-rounded-top-5";
        event.target.parentElement.className = "btn active g-bg-main  g-color-white";
        this.pageShown = tab;
    },
    GetForm() {
      this.GetSelectValues();
      this.GetAccountValues();
      this.GetEditValues();
    },
    GetSelectValues() {
      var _this = this;
      axios
        .post("/Util/GetEnums", this.AccountEnums)
        .then(function(response) {
          _this.CheckboxBusiness = response.data.raw.OrganizationBusinessCFS;
          _this.CheckboxIndividual = response.data.raw.OrganizationIndividual;
          _this.State = response.data.raw.State;
          _this.Suffix = response.data.raw.Suffix;
          _this.RoleBusiness = response.data.raw.RoleBusiness;
          _this.RoleNonProfit = response.data.raw.RoleNonProfit;
          _this.BusinessTypeIndividual =
            response.data.raw.BusinessTypeIndividual;
          _this.BusinessTypeBusiness = response.data.raw.BusinessTypeBusiness;
          _this.BusinessTypeNonProfit = response.data.raw.BusinessTypeNonProfit;
          _this.BusinessType = response.data.raw.BusinessType;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    GetAccountValues() {
      axios
        .get("/Account/self", {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        })
        .then(response => {
          this.isLoading = false;
          this.AccountView = response.data.raw;
          this.Account = response.data.raw;
          this.LoginFormInputs = this.FieldFlags.LoginInformation;
          if (response.data.raw.accountType == 1) {
            this.FormInputs = this.FieldFlags.Individual;
          } else if (response.data.raw.accountType == 2) {
            this.FormInputs = this.FieldFlags.Business;
          } else if (response.data.raw.accountType == 3) {
            this.FormInputs = this.FieldFlags.NonProfit;
          }
        })
        .catch(function(error) {
          console.log(error);
        if (error.response.status == 401)
      window.location.href="/";
        });
    },
    GetEditValues() {
      var _this = this;
      axios
        .get("/Account/self", {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        })
        .then(response => {
          _this.isLoadingEdit = false;
          _this.AccountEdit = response.data.raw;
          _this.EndLoad();
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status == 401)
          window.location.href="/";
        });
    },
    SuccessFade() {
      // this.$scrollTo("#errorDiv", 300, {
      //                   el: "#errorDiv",
      //                   offset: -100,
      //                   x: false,
      //                   y: true
      //               });
      this.isSuccess = !this.isSuccess;
      this.SuccessFadeOut();
      document.body.classList.remove("body-overflow");
    },
    SuccessFadeOut() {
      var myTimerPromise = new Promise((resolve, reject) => {
        setTimeout(() => {
          // callback function for timer, gets called after the time-delay
          // Your timer is done now. Print a line for debugging and resolve myTimerPromise
          this.isSuccess = !this.isSuccess;
          resolve();
        }, 5000); // This promise will be resolved in 2000 milli-seconds
      });
    },
    StartLoad(){
      this.isFormLoading = !this.isFormLoading;
    },
    EndLoad(){
      var myTimerPromise = new Promise((resolve, reject) => {
        setTimeout(() => {
          // callback function for timer, gets called after the time-delay
          // Your timer is done now. Print a line for debugging and resolve myTimerPromise
          this.isFormLoading = false;
          resolve();
        }, 1000); // This promise will be resolved in 2000 milli-seconds
      });
    },
    RefreshAddDoctorForm() {
      this.NewDoctor = {
                        useLicenseNumber:false,
                        npiNumber:null,
                        licenseNumber:null,
                        state:null,
                        firstName:null,
                        lastName:null,
                        suffix:null,
                        emailAddress:null,
                        yearsInPractice:null,
                        organizations: {
                          list: [],
                          others: null
                        },
                        id: 0
                      }
    }
  },
  created() {
    this.GetForm();
    localStorage.setItem('is-active','my-account');
  }
};
</script>



// WEBPACK FOOTER //
// UserAccount.vue?f7ee812e